import { supabase } from './supabase';

export const listRoles = async () => {
  const { data, error } = await supabase.from('admin_role_profiles').select('*').order('name');
  if (error) throw error;
  return data || [];
};

export const saveRole = async ({ id, name, description, permissions }) => {
  const row = { name: name.trim(), description: (description || '').trim() || null, permissions };
  const q = id ? supabase.from('admin_role_profiles').update(row).eq('id', id).select().single()
    : supabase.from('admin_role_profiles').insert(row).select().single();
  const { data, error } = await q;
  if (error) throw new Error(error.code === '23505' ? 'Ya existe un perfil con ese nombre.' : error.message);
  // los administradores con este perfil quedan al día (copia visible en su ficha)
  if (id) await supabase.from('profiles').update({ admin_permissions: permissions }).eq('admin_role_id', id);
  return data;
};

export const deleteRole = async (id) => {
  const { error } = await supabase.from('admin_role_profiles').delete().eq('id', id);
  if (error) throw error;
};
